export const SectionOpportunities = () => {
    return (
        <section className="opportunities">
            <div className="container">
                <div className="opportunities__wrapper">
                    <div className="opportunities__item">
                        <div className="opportunities__item__title">
                            <h3>Choose</h3>
                        </div>
                        <div className="opportunities__description">
                            Сhoose what you liked in our collection of movies, games, TV series and cartoons. Choose the best with us.
                        </div>
                    </div>
                    <div className="opportunities__item">
                        <div className="opportunities__item__title">
                            <h3>Play</h3>
                        </div>
                        <div className="opportunities__description">
                            Play and don't forget to relax. Explore our service and enjoy the time spent here.
                        </div>
                    </div>
                    <div className="opportunities__item">
                        <div className="opportunities__item__title">
                            <h3>Enjoy</h3>
                        </div>
                        <div className="opportunities__description">
                            Enjoy your time and tell your friends. Perhaps this is where you will find what you were looking for.
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}